var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11719_57970",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11719_57970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16732 15.8346C2.7319 15.8346 2.35916 15.6796 2.04909 15.3695C1.73902 15.0595 1.58398 14.6867 1.58398 14.2513V4.7513C1.58398 4.31589 1.73902 3.94314 2.04909 3.63307C2.35916 3.323 2.7319 3.16797 3.16732 3.16797H15.834C16.2694 3.16797 16.6421 3.323 16.9522 3.63307C17.2623 3.94314 17.4173 4.31589 17.4173 4.7513V14.2513C17.4173 14.6867 17.2623 15.0595 16.9522 15.3695C16.6421 15.6796 16.2694 15.8346 15.834 15.8346H3.16732ZM9.50065 10.293L3.16732 6.33464V14.2513H15.834V6.33464L9.50065 10.293ZM9.50065 8.70964L15.834 4.7513H3.16732L9.50065 8.70964ZM3.16732 6.33464V4.7513V14.2513V6.33464Z",
    fill: "#FDFCFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.4cbd0f9ef3cde82e642e8ede44cebb5e.svg";
export { ForwardRef as ReactComponent };